import { useEffect, useRef, useState } from "react";
import { loggerSend } from "../helpers";

export const useCamera = () => {
  const cameraRef = useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [error, setError] = useState<Error>();

  const init = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (cameraRef.current) {
        cameraRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Error accessing camera:", err);
      loggerSend(err, {
        tags: ["useCamera", "camera-access"],
      });
      setError(err);
    }
  };

  const cleanUp = () => {
    if (cameraRef.current?.srcObject) {
      (cameraRef.current.srcObject as MediaStream)
        .getTracks()
        .forEach((track) => track.stop());
    }
  };

  const handleCapture = (
    onCaptured: (image: string) => void
  ): string | void => {
    const video = cameraRef.current;
    const canvas = canvasRef.current;

    if (video && canvas) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      if (context) {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const image = canvas.toDataURL("image/png");

        onCaptured(image);
      }
    }
  };

  useEffect(() => {
    init();
    return cleanUp;
  }, []);

  return {
    cameraRef,
    canvasRef,
    error,
    handleCapture,
  };
};
